import Config from "../config/config";

export const SEM_IMAGEM =
  "https://katuxa.sfo3.digitaloceanspaces.com/pdv/sem-imagem.jpg";

export const FOTO_TRATAMENTO =
  "https://katuxa.sfo3.digitaloceanspaces.com/pdv/foto_tratamento.jpg";

const hasItems = (list) => Array.isArray(list) && list.length > 0;

const urlsFromCdnList = (list) => {
  if (!hasItems(list)) return [];
  const withUrl = list.filter(
    (item) => item && typeof item.url === "string" && item.url.trim()
  );
  if (!withUrl.length) return [];

  withUrl.sort((a, b) => {
    if (a.principal && !b.principal) return -1;
    if (!a.principal && b.principal) return 1;
    return (Number(a.ordem) || 0) - (Number(b.ordem) || 0);
  });

  return withUrl.map((item) => String(item.url).trim());
};

/**
 * Só usa o campo legado `images` quando houver objetos utilizáveis.
 * Monta URL em /fotos/ a partir de produto+cor ou filename.
 */
const legacyUrlsFromImages = (product) => {
  if (!hasItems(product?.images)) return [];

  const usable = product.images.filter((item) => {
    if (!item) return false;
    if (typeof item === "string") {
      return !!item.trim() && !/system-menu/i.test(item);
    }
    const name = String(item.filename || item._id || "").trim();
    return !!name && !/system-menu/i.test(name);
  });

  if (!usable.length) return [];

  const out = [];
  if (product.produto != null && product.cor_produto != null) {
    const pos = usable.length > 1 ? "02" : "01";
    out.push(
      `${Config.base_fotos}/fotos/${product.produto}_${product.cor_produto}_${pos}.jpg`
    );
    if (pos === "02") {
      out.push(
        `${Config.base_fotos}/fotos/${product.produto}_${product.cor_produto}_01.jpg`
      );
    }
    // Variante thumb usada no carrinho
    out.push(
      `${Config.base_fotos}/thumb/${product.produto}_${product.cor_produto}_01.jpg`
    );
  }

  for (const item of usable) {
    const filename = String(
      typeof item === "string" ? item : item.filename || ""
    )
      .trim()
      .replace(/^.*\//, "");
    if (!filename || /^https?:\/\//i.test(filename)) continue;
    const url = `${Config.base_fotos}/fotos/${filename}`;
    if (!out.includes(url)) out.push(url);
  }

  return out;
};

/**
 * Ordem: images (legado) → imagens → imagens_miniaturas.
 * Se `images` estiver vazio/sem objetos úteis, usa os campos CDN.
 */
export const collectProductImageUrls = (product) => {
  if (!product) return [];

  const list = [];
  const push = (url) => {
    if (!url) return;
    const u = String(url).trim();
    if (!u || list.includes(u)) return;
    list.push(u);
  };

  for (const u of legacyUrlsFromImages(product)) push(u);
  for (const u of urlsFromCdnList(product.imagens)) push(u);
  for (const u of urlsFromCdnList(product.imagens_miniaturas)) push(u);

  if (!list.length && product.base64) {
    push(`data:image/jpeg;base64,${product.base64}`);
  }

  return list;
};

export const getProductThumbUrl = (product, fallback = SEM_IMAGEM) => {
  const urls = collectProductImageUrls(product);
  return urls[0] || fallback;
};

export const getProductGalleryItems = (
  product,
  maxImages = 5,
  fallback = SEM_IMAGEM
) => {
  const urls = collectProductImageUrls(product);
  if (!urls.length) {
    return [{ original: fallback, thumbnail: fallback }];
  }

  return urls.slice(0, maxImages).map((url) => ({
    original: url,
    thumbnail: url,
  }));
};

/** Handler de onError que percorre as URLs candidatas e cai no fallback. */
export const createImageFallbackHandler = (
  candidates,
  fallback = SEM_IMAGEM
) => {
  return (event) => {
    const img = event.currentTarget;
    const nextIndex = Number(img.dataset.fallbackIndex || 0) + 1;
    if (Array.isArray(candidates) && nextIndex < candidates.length) {
      img.dataset.fallbackIndex = String(nextIndex);
      img.src = candidates[nextIndex];
      return;
    }
    img.onerror = null;
    img.src = fallback;
  };
};

export default getProductThumbUrl;
